/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 * @module dashboard/filters/pagecontext/PageContextService
 * @see PageContext
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'@waca/dashboard-common/js/core/APIFactory'
], function( BaseClass, APIFactory) {

	var PageContextService = BaseClass.extend({

		init: function(options) {
			PageContextService.inherited('init', this, arguments);
			this.dashboard = options.features['API'];
			this.logger = options.features['Logger'];
			this.boardModel = options.features['internal'].getBoardModel();
		},

		getAPI: function() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [
					class PageContextServiceAPI {
						getPageContext() {}
					}
				]);
			}
			return this._api;
		},

		/**
		* Get public api of pageContext object
		*/
		getPageContext: function() {
			if (!this._pageContextAPI) {
				const pageContext = this.boardModel.get('pageContext');
				if (!pageContext) {
					this.logger.error(this, 'No pageContext in the board model.');
				} else {
					this._pageContextAPI = pageContext.getAPI();
				}
			}
			return this._pageContextAPI;
		},

		_deletePageContextEntries: function(deleteIDs, options) {
			if (!deleteIDs || deleteIDs.length <= 0) {
				return null;
			}

			const deletedEntries = [];
			const pageContext = this.getPageContext();
			deleteIDs.forEach(function(widgetId) {
				const entry = pageContext.updateFilterContext({
					_strictMatch: true,
					eventSourceId: widgetId,
					origin: 'visualization'
				}, {
					command: 'delete'
				},
				options
				);
				deletedEntries.push(entry);
			});
			return deletedEntries;
		},
		getLifeCycleHandlers: function () {
			return [
				{
					name: 'post:widget.delete',
					action: function (payload) {
						return this._deletePageContextEntries(payload.ids, { payloadData: { undoRedoTransactionId: payload.undoRedoTransactionId, transactionToken: payload.transactionToken } });
					}.bind(this)
				}
			];
		}
	});
	return PageContextService;
});
